import React, { Component } from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line
import Datamaps from 'datamaps';

class ReactDatamaps extends Component {
  constructor() {
    super();
    this.clear = this.clear.bind(this);
    this.drawMap = this.drawMap.bind(this);
    this.updateData = this.updateData.bind(this);
    this.styleFixes = this.styleFixes.bind(this);
    this.mapBaseHeight = 445;
  }

  componentDidMount() {
    this.drawMap();
  }

  componentDidUpdate() {
    this.clear();
    this.drawMap();
    this.updateData();
  }

  componentWillUnmount() {
    this.clear();
  }

  clear() {
    this.container.querySelector('.dataMap').innerHTML = '';
    delete this.map;
  }

  drawMap() {
    this.map = new Datamaps({
      ...this.props.datamap.data,
      element: this.container.querySelector('.dataMap'),
      // KFF-2323
      // We are passing in data even though we are going to be updating it
      // via updateChoropleth.  This is due to a hover issue in datamaps
      // where the previous fill color was being stored.
    });
    this.updateData();
    this.styleFixes();
  }

  updateData() {
    const {
      data,
      plugins,
      pluginData,
    } = this.props.datamap;
    this.map.updateChoropleth(data.data);

    if (plugins) {
      Object.keys(plugins).forEach((plugin) => {
        this.map.addPlugin(plugin, plugins[plugin]);
        this.map[plugin](pluginData || {});
      });
    }
    this.styleFixes();
  }

  styleFixes() {
    const element = this.container.querySelector('.dataMap');
    const legendRect =
      element.querySelector('.datamaps-legend').getBoundingClientRect();
    // For some reason in IE & FF the font-size isn't set, so we need to do that
    // Override OG DC's padding-bottom
    element.style['padding-bottom'] = 0;
    [].forEach.call(element.querySelectorAll('text'), (item) => {
      if ('12px' !== item.style['font-size']) {
        // eslint-disable-next-line no-param-reassign
        item.style['font-size'] = '12px';
      }
    });
    element.style.height = `${
      this.mapBaseHeight + (legendRect.bottom - legendRect.top) + 30
    }px`;
  }

  render() {
    const style = {
      position: 'relative',
      width: '753px',
      ...this.props.style,
    };

    return (
      <div ref={(container) => { this.container = container; }}>
        <div
          style={style}
          className={'dataMap'}
        />
      </div>
    );
  }
}

ReactDatamaps.propTypes = {
  datamap: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};

export default connect((state) => ({
  datamap: state.data.datamap,
}))(ReactDatamaps);



// WEBPACK FOOTER //
// ./app/components/datamap/reactDatamaps.js